import { Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import PermissionGuard from "@/shared/components/PermissionGuard";
import { useInstitutionAccess } from "@/shared/hooks/useInstitutionAccess";
import DocumentosInstituicaoPagina from "@/interno/instituicoes/paginas/DocumentosInstituicaoPagina";

/**
 * Permite que usuários institution_external acessem a página de documentos da sua instituição
 * sem precisar de permissão ao módulo instituicoes. Outros usuários passam pelo PermissionGuard.
 */
const InstitutionDocumentsRouteGuard = () => {
  const { id } = useParams<{ id: string }>();
  const { isExternalUser, institutionId, loading: accessLoading } = useInstitutionAccess();

  if (accessLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isExternalUser && institutionId === id) {
    return <DocumentosInstituicaoPagina />;
  }

  return (
    <PermissionGuard module="instituicoes">
      <DocumentosInstituicaoPagina />
    </PermissionGuard>
  );
};

export default InstitutionDocumentsRouteGuard;
